<div class="shadow-lg rounded px-4 py-4 my-5 container" [hidden]="!contractListSorted.length">
    <h3 class="text-muted text-center mb-2">Contratos</h3>

    <mat-form-field class="mx-3" appearance="fill" [floatLabel]="'auto'">
        <mat-label>Descrição do Contrato</mat-label>
        <input [(ngModel)]="filterTable.description" matInput name="contractDescription" type="text" />
        <button mat-icon-button matSuffix>
            <mat-icon>search </mat-icon>
        </button>
    </mat-form-field>
    <mat-form-field appearance="fill" [floatLabel]="'auto'">
        <mat-label>Aluno</mat-label>
        <input [(ngModel)]="filterTable.fullName" matInput name="fullnamePerson" type="text" />
        <button mat-icon-button matSuffix>
            <mat-icon>search </mat-icon>
        </button>
    </mat-form-field>

    <table matSort (matSortChange)="onSortData($event)" class="table table-hover table-sm pointer">
        <thead>
            <tr style="cursor: pointer !important">
                <th header="selected" class="w-1">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            (change)="masterToggle()"
                            type="checkbox"
                            value=""
                            id="flexCheckChecked"
                            [checked]="isAllSelected()" />
                        <label class="form-check-label" for="flexCheckChecked"> All </label>
                    </div>
                </th>
                <th mat-sort-header="description" class="w-1">Descrição</th>
                <th mat-sort-header="periodDescription" class="w-1">Periodo</th>
                <th mat-sort-header="levelDescription" class="w-1">Nivel</th>
                <th mat-sort-header="fullName" class="w-1">Aluno</th>
                <th class="w-1">
                    <div class="justify-content-center d-flex">
                        <button
                            [disabled]="isLoading | async"
                            (click)="onGenerateList()"
                            mat-raised-button
                            color="accent">
                            Gerar Selecionados <mat-icon>refresh</mat-icon>
                            <label [hidden]="!contractListSorted.length"> ({{ countSelected() }}) </label>
                        </button>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                (click)="changeSelected(contract)"
                *ngFor="
                    let contract of contractListSorted
                        | filter: { description: filterTable.description }
                        | filter: { fullName: filterTable.fullName };
                    index as i
                ">
                <td>
                    <div class="form-check">
                        <input
                            [checked]="contract.selected"
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault" />
                        <label class="form-check-label" for="flexCheckDefault"> </label>
                    </div>
                </td>
                <td>{{ contract.description }}</td>
                <td>{{ contract.periodDescription }}</td>
                <td>{{ contract.levelDescription }}</td>
                <td>{{ contract.fullName }}</td>
                <td>
                    <button
                        matTooltip="Gerar Mapeamento"
                        [disabled]="isLoading | async"
                        matTooltipClass="text-light bg-dark"
                        (click)="onGenerate(contract.contractId)"
                        mat-icon-button
                        color="accent">
                        <mat-icon>refresh</mat-icon>
                    </button>

                    <button
                        matTooltip="Verificar Mapeamento"
                        [disabled]="isLoading | async"
                        matTooltipClass="text-light bg-dark"
                        (click)="onClickContract(contract.contractId)"
                        mat-icon-button
                        color="primary">
                        <mat-icon>search</mat-icon>
                    </button>

                    <button
                        matTooltip="Ir para Contrato"
                        [disabled]="isLoading | async"
                        matTooltipClass="text-light bg-dark"
                        mat-button
                        (click)="goToAfsContract(contract.contractId)"
                        mat-icon-button>
                        <mat-icon color="primary">arrow_forward_ios</mat-icon>
                    </button>
                </td>
                <td *ngIf="contract.hasMapping">
                    <mat-icon matTooltip="Mapeado" color="accent">check</mat-icon>
                </td>
            </tr>
        </tbody>
    </table>
</div>
